import { render } from "./VoluntaryDetail.vue?vue&type=template&id=1d021cda"
import script from "./VoluntaryDetail.vue?vue&type=script&lang=ts"
export * from "./VoluntaryDetail.vue?vue&type=script&lang=ts"
script.render = render

export default script